var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotificationFill(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Notification") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/NotificationFill",
    fill: "#6C7DBC",
    stroke: "#6C7DBC",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,3.25 C12.7448718,3.25 13.3461538,3.85128205 13.3461538,4.59615385 L13.3461538,4.59615385 L13.3461538,5.20641026 C15.9128205,5.81666667 17.3846154,8.12307692 17.3846154,10.8782051 L17.3846154,10.8782051 L17.3846154,15.3653846 L19.1794872,17.1602564 L19.1794872,18.0576923 L13.8785128,18.057 L13.8788421,18.8711579 C13.8788421,19.8553133 13.1119678,20.6690522 12.1462742,20.7443194 L12,20.75 C10.9572426,20.75 10.1211579,19.9045211 10.1211579,18.8711579 L10.1211579,18.8711579 L10.1205128,18.057 L4.82051282,18.0576923 L4.82051282,17.1602564 L6.61538462,15.3653846 L6.61538462,10.8782051 C6.61538462,8.11410256 8.07820513,5.81666667 10.6538462,5.20641026 L10.6538462,5.20641026 L10.6538462,4.59615385 C10.6538462,3.85128205 11.2551282,3.25 12,3.25 Z",
    id: "Combined-Shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationFill);
export default __webpack_public_path__ + "static/media/NotificationFill.671037e3adfbb19dd6848946fff32813.svg";
export { ForwardRef as ReactComponent };